import {ANNOTATION_VIDEO_DISPLAY, ANNOTATION_PARENT, VIDEO_PLAYING_MODE, ANNOTATION_LOCATION} from './GlobalConstants';
import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';

export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/swpa%2F2021%2Fswp-awards%2F";

export const ANNOTATION_TEXT_ALIGNMENT = "justify";
export const ANNOTATION_TEXT_LINE_HEIGHT = "1.5";
// export const GALLERY_LINK_LABEL = "WORKS";
export const GALLERY_LINK_LABEL = `<img src='/assets/languages/iconfinder_uk.png'>`;


const AnnotationsDB = [


    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
    //     headerText: `<h5></h5>`,
    //     bodyText: ``,
    //     // urlLink1Label: ,
    //     // urlLink1: ,
    // },
    //
    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //     headerText: `<h5></h5>`,
    //     bodyText: ``,
    //     // urlLink1Label: ,
    //     // urlLink1: ,
    // },


    /* Room 1 */
    // {
    //     paintingId: 'R1N01',
    //     videoId: 'R1N01',
    //     standaloneVideoElementId: 'R1N01',
    //     videoURL: 'R1N01.mp4',
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1N01.jpg/info.json`,
    //     headerText: '<h5>Dominant Motion</h5>',
    //     bodyText: `<b>Toby Ashworth</b><br>Digital video<br><br>The bewildering movement of light in this image is actually the product of a camera unable to focus on the reflections of sunlight playing on the surface of a river. With the colour removed, the image and its source are deterritorialised. I like to think of it as a visualisation of thought processes (overthinking?) or perhaps networks of people, things, or ideas.`,
    //     displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
    //     displayMesh: 'N',
    //     // displayHeight: 90,
    //     videoAutoPlay: 'N',
    //     // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
    //     // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
    //     // videoButtonScale: {x: .2, y: .2, z: .2},
    //     // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
    //     videoTextureEncoding: THREE.sRGBEncoding,
    //     // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    //     useVideoMeshButton: 'Y',
    //
    //
    // },
    // {
    //     paintingId: 'R1E04C',
    //     videoId: null,
    //     videoURL: null,
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}R1E04.jpg/info.json`,
    //     headerText: '<h5>Winter</h5>',
    //     bodyText: `<b>Abby Wheeler</b><br>Pencil and watercolour pencil on paper<br><br>Like a lot of people, I started going back to old hobbies over the last year, since I suddenly had the time and necessity for a creative output. For these pieces, specifically, I wanted to capture the feeling of being inside in a grey, desaturated world while the colourful seasons passed - so fast it felt like just one day. I think it's a feeling that has become all too familiar to a lot of us. My style (the product of a fear of painting people and an inability to sketch landscapes) happened to fit this fairly well, and so this project was born.`,
    //     instagramUrl: 'instagram.com/apparently.abby',
    // ContactURL: 'https://yazikovnik.com/',
    // },

    // {
    //     paintingId: 'R1E02',
    //     videoId: null,
    //     videoURL: null,
    //     hasCarouselAsParent: 'Y',
    //     carouselAnnotationSiblings: ['R1E01C', 'R1E02C', 'R1E03C', 'R1E04C'],
    //     // annotation_location_vert_offset: PLINTH_01_VER_OFFSET,
    //     // annotation_location_horiz_offset: W07_HORZ_OFFSET,/
    //     // annotation_location_z_offset: 0.5,
    //     // annotation_location: ANNOTATION_LOCATION.BOTTOM_RIGHT,
    //annotationTextAlignment: 'center',
    // },

    /* Audio */
    {
        paintingId: 'ARCA01',
        videoId: 'ARCA01',
        standaloneVideoElementId: 'ARCA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'ARCA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'ARCA02',
        videoId: 'ARCA02',
        standaloneVideoElementId: 'ARCA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'ARCA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'ARCA03',
        videoId: 'ARCA03',
        standaloneVideoElementId: 'ARCA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'ARCA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'CREA01',
        videoId: 'CREA01',
        standaloneVideoElementId: 'CREA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'CREA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'CREA02',
        videoId: 'CREA02',
        standaloneVideoElementId: 'CREA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'CREA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'CREA03',
        videoId: 'CREA03',
        standaloneVideoElementId: 'CREA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'CREA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'PORA01',
        videoId: 'PORA01',
        standaloneVideoElementId: 'PORA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'PORA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'PORA02',
        videoId: 'PORA02',
        standaloneVideoElementId: 'PORA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'PORA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'PORA03',
        videoId: 'PORA03',
        standaloneVideoElementId: 'PORA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'PORA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'DOCA01',
        videoId: 'DOCA01',
        standaloneVideoElementId: 'DOCA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'DOCA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'DOCA02',
        videoId: 'DOCA02',
        standaloneVideoElementId: 'DOCA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'DOCA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'DOCA03',
        videoId: 'DOCA03',
        standaloneVideoElementId: 'DOCA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'DOCA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'ENVA01',
        videoId: 'ENVA01',
        standaloneVideoElementId: 'ENVA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'ENVA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'ENVA02',
        videoId: 'ENVA02',
        standaloneVideoElementId: 'ENVA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'ENVA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'ENVA03',
        videoId: 'ENVA03',
        standaloneVideoElementId: 'ENVA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'ENVA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'LANA01',
        videoId: 'LANA01',
        standaloneVideoElementId: 'LANA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'LANA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'LANA02',
        videoId: 'LANA02',
        standaloneVideoElementId: 'LANA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'LANA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'LANA03',
        videoId: 'LANA03',
        standaloneVideoElementId: 'LANA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'LANA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'NWWA01',
        videoId: 'NWWA01',
        standaloneVideoElementId: 'NWWA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'NWWA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'NWWA02',
        videoId: 'NWWA02',
        standaloneVideoElementId: 'NWWA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'NWWA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'NWWA03',
        videoId: 'NWWA03',
        standaloneVideoElementId: 'NWWA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'NWWA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'POTA01',
        videoId: 'POTA01',
        standaloneVideoElementId: 'POTA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'POTA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'POTA02',
        videoId: 'POTA02',
        standaloneVideoElementId: 'POTA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'POTA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'POTA03',
        videoId: 'POTA03',
        standaloneVideoElementId: 'POTA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'POTA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'SPOA01',
        videoId: 'SPOA01',
        standaloneVideoElementId: 'SPOA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'SPOA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'SPOA02',
        videoId: 'SPOA02',
        standaloneVideoElementId: 'SPOA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'SPOA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'SPOA03',
        videoId: 'SPOA03',
        standaloneVideoElementId: 'SPOA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'SPOA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'STIA01',
        videoId: 'STIA01',
        standaloneVideoElementId: 'STIA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'STIA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'STIA02',
        videoId: 'STIA02',
        standaloneVideoElementId: 'STIA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'STIA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'STIA03',
        videoId: 'STIA03',
        standaloneVideoElementId: 'STIA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'STIA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    /* Audio */


    /* PRO & OPEN */
    /* Architecture */
    {
        paintingId: 'ARC0103',
        // paintingId: 'CAR0103',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ARC0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0104.jpg/info.json`],
        headerText: `<h5>Tomáš Vocelka</h5>`,
        bodyText: `<i>Eternal Hunting Grounds (Pet Crematorium by architect Petr Hajek)</i><br><br>The former Drnov military complex has been abandoned for 17 years when two friends, Martin Chlum and Michal Seba, bought the dilapidated facility in order to realise their dream of building a final resting place for pets. Explaining the reason for pursuing this project one of the owners reflects:  ‘When my dog died, I found that there weren't any places where I could take him for cremation or burial’. With the help of Czech minimalist architect Petr Hajek they established what is now known as the Eternal Hunting Grounds, a space comprising a mourning hall, a crematorium and approximately 40 hectares of surrounding land where wildlife can thrive.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ARC0203',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ARC0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0203.jpg/info.json`],
        headerText: `<h5>Frank Machalowski</h5>`,
        bodyText: `<i>Meisterhäuser Bauhaus-Dessau</i><br><br>Over the past few years, I have visited and photographed Walter Gropius’s Masters’ Houses in Dessau numerous times. The images form a body of work called Multiexpo, and are all taken on film, using multiple exposure techniques.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ARC0304',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ARC0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0303.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0304.jpg/info.json`],
        headerText: `<h5>Gu Guanghui</h5>`,
        bodyText: `<i>Hymn of the Building Site</i><br><br>I often visit this building site in Ninghai County, Zhejiang Province, China for work reasons. Using a drone, I photographed them to show the work that takes place each day.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ARC0401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARC0401.jpg/info.json`,
        headerText: `<h5>Klaus Lenzen</h5>`,
        bodyText: `<i>The blue window</i><br><br>The stairs at the Hyatt hotel in Düsseldorf, Germany.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* Architecture */

    /* Creative */
    {
        paintingId: 'CRE0103',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CRE0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0104.jpg/info.json`],
        headerText: `<h5>Mark Hamilton Gruchy</h5>`,
        bodyText: `<i>The Moon Revisited</i><br><br>This body of work is made up of previously unprocessed images from NASA and the Jet Propulsion Laboratory. I have made my own images to express not only contemporary issues but also some that were relevant at the time of the Apollo missions. These are sourced from copyright-free materials that I have repurposed, processed and composited to create a conversation about the unchanging aspect of the Moon contrasted with the Earth, which continues to be a dynamic place where change cannot be prevented. With thanks to NASA and the JPL.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'CRE0203',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CRE0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0203.jpg/info.json`],
        headerText: `<h5>Luigi Bussolati</h5>`,
        bodyText: `<i>Ampelio and I</i><br><br>After months of searching, I finally found the tatty photo album I’d been looking for. It belonged to an uncle who, like me, was a passionate photographer. He lived along the banks of the Po, a river in northern Italy, between the end of the 19th century and the early 20th century. After taking his own life in his darkroom in 1942, almost everything that belonged to him and that he had produced, including photographs, was destroyed. In the spring of 2020, at the beginning of lockdown in Italy, I had the idea that I could project his photographs onto the landscape of Parma, merging his vision with mine. With this project, the river has become a long and infinite darkroom from whose waters this latent gaze has emerged.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'CRE0304',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CRE0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0303.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0304.jpg/info.json`],
        headerText: `<h5>Sasha Bauer</h5>`,
        bodyText: `<i>Sasha Bauer</i><br><br>A new ethnic group of German colonists emerged in the mid-18th century, when Empress Catherine II published ‘Manifesto on Allowing Foreigners to Settle in Russia’ in 1762. But by the beginning of the 20th century, they became hostages of interrelations between Russia (then USSR) and Germany, which were enemies in two world wars. Two months after the start of the Great Patriotic War, the Presidium of the USSR adopted a decree, ‘On the resettlement of Germans living in the Volga region’, as a result of which the entire German population (more than 800,000 Germans) was deported to Siberia and Kazakhstan.<br>Among them was my grandfather, who lost his parents in labour camps. He lived in an orphanage and served in the Russian army, but was not afraid to keep his German surname. This project is a visual statement about my connection with my grandfather through genes and the same name.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'CRE0401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}CRE0401.jpg/info.json`,
        headerText: `<h5>Tamary Kudita</h5>`,
        bodyText: `<i>African Victorian</i><br><br>With this image, I wanted to portray a hybrid African-Victorian: my way of probing the stereotypical contextualisation of the black female body. I provide an alternative version of reality, where dualities fuse to create a new visual language. Taking a Victorian dress and merging it with traditional shona cooking utensils was my way of showing a multifaceted identity.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* Creative */

    /* Portfolio */
    {
        paintingId: 'POR0102',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POR0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0104.jpg/info.json`],
        headerText: `<h5>Laura Pannack</h5>`,
        bodyText: `<i>Portfolio Overview</i><br><br>These images are from a variety of personal projects. All of my work is driven by research and building a connection with those I photograph, while vulnerability and honesty are at the forefront of my process. Such collaborations enable my imagery to be playful and push the boundaries of portraiture, while ensuring a foundation of trust is consistent. I believe images need to captivate and evoke emotion, and so, with every frame I shoot, I consider the elements within the frame and outside it. Symbolism is an important reference for my choices of composition and content.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'POR0201',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POR0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0203.jpg/info.json`],
        headerText: `<h5>Brais Lorenzo</h5>`,
        bodyText: `<i>My Work in the Year 2020</i><br><br>Taken in and around his hometown of Ourense in the region of Galicia, photojournalist Brais Couto presents a series of poignant and dramatic scenes exploring local events and issues ranging from the effects of the pandemic to forest fires and carnival season`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'POR0302',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POR0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0303.jpg/info.json`],
        headerText: `<h5>Loli Laboureau</h5>`,
        bodyText: `<i>Citizens of Tomorrow</i><br><br>Citizens of Tomorrow started as my personal project during the quarantine. It's a work in progress that combines the world as we used to know it and a series of portraits, describing the new normal in a dramatic way.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'POR0401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}POR0401.jpg/info.json`,
        headerText: `<h5>Khanh Phan</h5>`,
        bodyText: `<i>Drying Fish</i><br><br>A woman dries trays of fish at Long Hai fish market in the Vung Tau province of Vietnam. Thousands of trays of scad are dried on rooftops and in yards by hundreds of workers. I came to Long Hai on a photo trip and was overwhelmed by the scale of the fishing village.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* Portfolio */

    /* Documentary Projects */
    {
        paintingId: 'DOC0104',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}DOC0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0104.jpg/info.json`],
        headerText: `<h5>Vito Fusco</h5>`,
        bodyText: `<i>The Killing Daisy</i><br><br>The pyrethrum is known as the ‘flower of death’ – a nickname that neatly describes this delicate daisy imbued with murderous power. The pyrethrum is cultivated mainly in the hills of Nakuru in Kenya and is the arch foe of the insect world. When insects encounter the substance they are stunned into paralysis and then die. Used for centuries as a natural insecticide, it was only in the mid-20th century that pyrethrum made an impact on the global pesticides market, earning an eminent position among natural insecticides. During the 1980s, the pyrethrum crisis began, instigated by the chemical synthesis of pyrethroids that led to the manufacturing of cheaper but non-organic products. Today, however, this special daisy is being grown once again on the clay hills of Nakuru at an altitude of over 1,500m. The Kenyan government has decided to liberalise the production of pyrethrum, opening it to private companies in an ambitious attempt to revive the sector and help local farmers meet the growing global demand for organic products. Once sown, the plant provides a yield approximately every 15 days, all year round.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'DOC0203',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}DOC0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0203.jpg/info.json`],
        headerText: `<h5>Craig Easton</h5>`,
        bodyText: `<i>Thatcher's Children</i><br><br>Thatcher’s Children investigates the chronic intergenerational nature of poverty, exploring the effects of successive governments’ social policies as experienced by three generations of one family in the north of England. I first met the Williams family in Blackpool in 1992: two parents and six children living in a hostel for homeless families. They were trapped in a cycle of unemployment and poverty. I had long wondered what became of the family; I finally traced them in 2016 and have been working with them ever since. The six children now have almost 30 children between them, almost all living in similar conditions to those in which I found them in 1992. Now, however, they are trapped by zero-hours contracts and ‘in-work poverty’. I see their experience as being illustrative of what happened to a society that was left behind by the social policies implemented in the 1980s and ’90s.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'DOC0303',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}DOC0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0303.jpg/info.json`],
        headerText: `<h5>Lorenzo Tugnoli</h5>`,
        bodyText: `<i>Beirut Port Explosion</i><br><br>A few minutes after 6pm on August 4, 2020, a massive explosion shook Beirut, obliterating its port and destroying swathes of the city. At least 200 people were killed and more than 6,000 injured when 2,750 tons of ammonium nitrate detonated. The material had been stored in a warehouse in Beirut’s port since being seized by custom authorities in 2014, despite repeated warnings of the danger from port officials and its proximity to a densely populated area of the city. In the following days, as bodies continued to be pulled from the rubble, protesters occupied government ministries, set fires and faced off against security forces.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'DOC0401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DOC0401.jpg/info.json`,
        headerText: `<h5>F.Dilek Uyar</h5>`,
        bodyText: `<i>Disinfection</i><br><br>During the coronavirus pandemic, the Health Affairs unit of Ankara Municipality sprays all public transportation, day and night.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* Documentary Projects */

    /* Environment */
    {
        paintingId: 'ENV0103',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ENV0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ENV0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ENV0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ENV0104.jpg/info.json`],
        headerText: `<h5>Simone Tramonte</h5>`,
        bodyText: `<i>Net-zero Transition</i><br><br>The coronavirus pandemic has led to the most severe economic downturn the world has seen in recent years. However, this crisis also presented countries with an unprecedented opportunity to shift towards sustainable living. Iceland is isolated and challenged by a harsh climate and following the financial crisis in 2008 has successfully transformed its economy through the use of renewable energy. In a few decades, the country moved away from fossil fuels to producing 100% of its electricity from renewable sources. This transition nurtured an ecosystem of innovation and entrepreneurship that grew profitable businesses aiming to make minimal impact on the environment. Thus Iceland has become a global leader in technologies that foster clean energy and emission reduction. This small nation presents many ways in which the global climate crisis can be tackled and is leading the transition to a net-zero sustainable future.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ENV0203',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ENV0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ENV0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ENV0203.jpg/info.json`],
        headerText: `<h5>Mohammad Madadi</h5>`,
        bodyText: `<i>A City Under Dust Clouds</i><br><br>Ahvaz has been consistently ranked as one of the world's worst cities for air pollution according to the World Health Organization, topping the list on numerous occasions in the past decade. Industrial sources, chief among them the refineries and other components of the vast petrochemical industry in Khuzestan Province, as well as massive dust storms, are the main contributors to air pollution. The poor air quality has a significant impact on the lives of the residents of Ahvaz. Each year, thousands seek medical treatment for respiratory conditions. The air pollution has also increased immigration out of the city, limited investments and tourism, damaged infrastructure, and added to the already high electricity and water consumption of the city.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ENV0302',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ENV0301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}ENV0302.jpg/info.json`],
        headerText: `<h5>Antonio Pérez</h5>`,
        bodyText: `<i>The Sea Moves Us, the Sea Moves Fuvemeh</i><br><br>Fuvemeh, Ghana, a fishing village located between the Atlantic Ocean and the mouth of the Volta River, has disappeared. It cannot even be found on Google Maps, and now only exists in the memories of those who lived there. Coastal erosion and rising sea levels – a direct consequence of global warming – are contributing to the disappearance of coastal communities in West Africa. Fuvemeh is a clear example of this.<br>Over the years, the inhabitants of this village, little by little, saw their lands, their houses and their livelihoods disappear. The defenses, barriers and breakwaters, built by cooperation projects, have also been swallowed up by the sea. Those inhabitants of Fuvemeh who are able to have fled to other villages, other houses, other countries. Some remain, only a few hundred metres from the shore, hoping the sea will not swallow their lives up again.  Sometimes, at low tide, they return to what is left of their houses: walls; windows; a doorframe. Sometimes there is nothing. It’s an empty space, which the people fill with their memories. These photographs of the people and what remains of their house are taken in those moments.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ENV0401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ENV0401.jpg/info.json`,
        headerText: `<h5>Mariano Belmar</h5>`,
        bodyText: `<i>Días de Playa</i><br><br>Summer, Mediterranean Sea, Spain, Alicante, beach and morning walk: a way of life.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* Environment */

    /* Landscape */
    {
        paintingId: 'LAN0102',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAN0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAN0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAN0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAN0104.jpg/info.json`],
        headerText: `<h5>Majid Hojjati</h5>`,
        bodyText: `<i>Silent Neighborhoods</i><br><br>Everything in life is made up of impressions from the past and whatever befalls us today. The fabric which took one form yesterday takes on a new form now. All creatures still fight for their survival. Nature is the battlefield. The forces of the world are as they have ever been; the waves of the sea, storms, the earth itself. But ultimately it is humanity, marching everywhere, claiming everything, proving to the world that it will endure. We strove to live, to take and to control, before even knowing what to call ourselves. We think we will last forever so we hunt, build, wear clothes and consume, changing our ideas and our tools over the years but never changing our ways. We chased after more and more and something was always left behind. Homes were abandoned, chairs left empty and clothes unworn, even the buttons of a shirt were lost. We have raced to eternity, knowing life is fleeting, leaving the lights on behind us as if to say that once upon a time we were alive. Here are the silent neighbourhoods: those places free of the presence of humanity. The noise of their silence can be heard everywhere – but here in these places we are condemned to hear nothing.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAN0202',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAN0201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAN0202.jpg/info.json`],
        headerText: `<h5>Andrea Ferro</h5>`,
        bodyText: `<i>Zaïm</i><br><br>In Arab cultures, depicting living beings is strictly connected to idolatry. The Quran condemns the worship of idols, since God should be the only subject of veneration. However, in Lebanon as well as in other majority Muslim countries, the use of images for propaganda purposes portrays politicians and local personalities almost as ‘divinities’ to be venerated. Tripoli is the second largest city in Lebanon by population and size, and is considered by the UN to be the poorest city on the Mediterranean coast. It is also probably the Lebanese city where the presence of representations of both local and national personalities has the strongest visual impact. My project reveals the correlation between devotional aspects of iconography and its pervasiveness at a spatial and urban level.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAN0302',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAN0301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAN0302.jpg/info.json`],
        headerText: `<h5>Fyodor Savintsev</h5>`,
        bodyText: `<i>Volcano</i><br><br>I took these photographs during my first trip to the volcanoes of Kamchatka in eastern Russia. I visited in the autumn, when there is no snow covering the volcanoes, and was struck by how the yellowing leaves looked against the black ash. My visit lasted around two weeks and I photographed in all different weather conditions and times of the day. The Kamchatka Peninsula is completely different from anything else I’ve seen. I was completely absorbed by its beauty and wanted to portray the volcanic belt as a living organism. I plan to continue the series this year.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAN0401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LAN0401.jpg/info.json`,
        headerText: `<h5>Juan López Ruiz</h5>`,
        bodyText: `<i>Electric Storm on Lavender</i><br><br>Electric storm above a solitary tree in the lavender fields of Brihuega, Guadalajara, Spain.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* Landscape */

    /* Wildlife & Nature */
    {
        paintingId: 'NWW0103',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}NWW0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NWW0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NWW0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NWW0104.jpg/info.json`],
        headerText: `<h5>Luis Tato</h5>`,
        bodyText: `<i>Locust Invasion in East Africa</i><br><br>Desert locusts are the most destructive migratory pests in the world. Thriving in moist conditions in semi-arid to arid environments, billions of locusts have been feeding throughout East Africa, devouring everything in their path, and posing a huge threat to the food supply and livelihoods of millions of people. Farmers stand by as armies of ravenous insects eat their crops; meanwhile, herders watch the rangelands stripped bare before their livestock can get to them. Extreme rainfall events and severe weather anomalies have created ideal conditions for locust breeding and feeding. Swarms of desert locusts from the Arabian Peninsula began rampaging across East Africa in early 2020, devouring crop and vegetation where they landed. The crisis reached historic proportions, with 10 countries in the Greater Horn of Africa and Yemen experiencing infestations. Some areas of East Africa, such as Kenya, had not seen such severe desert locust outbreaks in more than 70 years. Covid-19 restrictions have significantly slowed efforts to fight the infestation, as crossing borders has become more difficult, creating delays and disrupting the supply chains of pesticides and products needed to prevent these pests from wiping out vegetation across the region and exposing millions of people to high levels of food insecurity.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NWW0203',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}NWW0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NWW0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NWW0203.jpg/info.json`],
        headerText: `<h5>Graeme Purdy</h5>`,
        bodyText: `<i>Raw Nature</i><br><br>This series of images was taken using wide angle lenses and wireless triggers. With these iconic wild animals, being in close proximity is too dangerous, so you need to be inventive and innovative. This unique perspective is complemented by an aerial image of a hippo pod, as well as underwater images inches away from wild crocodiles. I have aimed for a unique perspective showing the raw beauty and power of the wild; hopefully, through more empathy with nature, we will learn to preserve it. All animals are wild and free.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NWW0301',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}NWW0301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}NWW0302.jpg/info.json`],
        headerText: `<h5>Angel Fitor</h5>`,
        bodyText: `<i>Sea Drops</i><br><br>‘I have imagined the ocean as a superorganism, with the world's seas as its organs, and its creatures as the tissues that interconnect everything. Sinking further down on to it, there is nothing… but sea drops.’<br>This figurative concept opens Sea Drops, a photo essay aimed to explore the effervescence of life inside drops of sea water. By using lab micropipettes, and a self-designed micro studio setup, the project captures the beauty and manners of live plankton, which are in the range of 200 to 1,500 microns, inside specially lit drops of water. It tells the story of one of Earth's most pivotal biological communities with an innovative perspective, falling somewhere between art and science. The images reveal the astonishing diversity of creatures otherwise invisible to the naked eye, as well as their amazing behaviour, some of which is likely never to have been documented before. It may even be new to science. From the enthralling beauty of sea sapphires, to the mesmerisingly mysterious dances of annelid worms, the project opens a drop-shaped window to a new world. All specimens were carefully handled under a biologist's expertise, and released alive and unharmed back into the sea.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NWW0401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NWW0401.jpg/info.json`,
        headerText: `<h5>Cristo Pihlamäe</h5>`,
        bodyText: `<i>Little Kiss</i>`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* Wildlife & Nature */

    /* Portraiture */
    {
        paintingId: 'POT0109',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POT0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0104.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0105.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0106.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0107.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0108.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0109.jpg/info.json`],
        headerText: `<h5>Craig Easton</h5>`,
        bodyText: `<i>Bank Top</i><br><br>Bank Top, a collaboration with writer and academic Abdul Aziz Hafiz, examines the representation and misrepresentation of communities in northern England, and focuses on a tight-knit neighbourhood in Blackburn. Craig Easton notes that Blackburn has become synonymous with the use of words such as segregation (BBC Panorama) and integration (The Casey Review) by the media and policy makers – terms which he believes are too simplistic to explain the challenges faced by such neighbourhoods and towns. His aim with Bank Top is to confront what he sees as dominant discourses in the media which fail to acknowledge the historical legacy and social costs of industrial expansion and colonialism. This long-form collaboration uses the stories and experiences in Bank Top to address wider issues around social deprivation, housing, unemployment, immigration and representation, as well as the impact of past and present foreign policy.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'POT0204',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POT0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0203.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0204.jpg/info.json`],
        headerText: `<h5>Julia Fullerton-Batten</h5>`,
        bodyText: `<i>Looking Out from Within, 2020</i><br><br>Time stands still for most of us. It is a sensitive time; we all feel vulnerable and anxious. I felt numb, but I knew I couldn’t stand around and do nothing, so I decided to document today’s existence as lived now by many people. I chose to capture them in their lockdown isolation, effectively imprisoned behind the windows of their homes looking out onto a different desolate world. My 12-year old son helped carry the lighting.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'POT0303',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POT0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0303.jpg/info.json`],
        headerText: `<h5>Jane Hilton</h5>`,
        bodyText: `<i>Drag Queen Cowboys</i><br><br>These portraits were taken just before the pandemic reached the USA in February 2020. Drag Queen Cowboys is a collaboration with the vibrant community of performers based in Las Vegas. Set in Nevada, and inspired by the locations and displacement of characters in John Houston’s film The Misfits (1961), all drag queens chose and painstakingly made theiCitizens of Tomorrowr own ‘Western’ outfits; including accessories, wigs and applying their own make-up. After gaining their trust, I steered them away from their nocturnal habitat of bars and clubs. With no artificial lighting or digital technology, I shot these portraits on black-and-white film, using a plate camera, in the natural light of the American West.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'POT0401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}POT0401.jpg/info.json`,
        headerText: `<h5>Lyudmila Sabanina</h5>`,
        bodyText: `<i>Son</i><br><br>Another side of childhood: contemplation and calm.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* Portraiture */

    /* Sport */
    {
        paintingId: 'SPO0103',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SPO0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0104.jpg/info.json`],
        headerText: `<h5>Anas Alkharboutli</h5>`,
        bodyText: `<i>Syria: Sport and Fun Instead of War and Fear</i><br><br>In the Syrian village of Aljiina, near the city of Aleppo, Wasim Satot has opened a karate school for children. What makes it special is that girls and boys with and without disabilities are taught together. They’re aged between six and 15 years old. With his school, Satot wants to create a sense of community and overcome any traumas of war in the minds of the children.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'SPO0203',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SPO0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0203.jpg/info.json`],
        headerText: `<h5>Patrick Meinhardt</h5>`,
        bodyText: `<i>Iron Fit Kenya</i><br><br>In March 2020, Kenya halted all sporting activities to stop the spread of Covid-19, alongside other measures such as closing borders and schools, and imposing a nighttime curfew. Six months later, Sports Minister Amina Mohamed gave the green light for non-contact sports to resume, allowing fitness enthusiasts to participate in the second Iron Fit Bodybuilding competition in Nairobi. One hundred and thirty athletes from all across East Africa took part in this event, which included categories such as Bikini, Figure, Physique and Bodybuilding.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'SPO0303',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SPO0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0303.jpg/info.json`],
        headerText: `<h5>Seyed Ali (Farzam) Saleh</h5>`,
        bodyText: `<i>Rooftop</i><br><br>n March 2020, in reaction to the Covid-19 outbreak, the Iranian government announced the immediate closure of all athletic venues, sports clubs and training centres across Iran. Following the implementation of this mandate, athletes in Iran took to training on the rooftops of their homes in order to maintain a degree of their physical and mental fitness and prowess.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'SPO0401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}SPO0401.jpg/info.json`,
        headerText: `<h5>Marijo Maduna</h5>`,
        bodyText: `<i>Girl Power</i><br><br>A young girl shows off her skills, diving from a cliff on the island of Lokrum in Croatia.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* Sport */

    /* Still Life */
    {
        paintingId: 'STI0103',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STI0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0103.jpg/info.json`],
        headerText: `<h5>Peter Eleveld</h5>`,
        bodyText: `<i>Still Life Composition, Shot on  Wet Plate</i><br><br>For this project I used ordinary objects, like glassware, fruits and flowers and applied the wet plate collodion technique to turn them into something extraordinary. Once I found my subject I started imagining how it will look printed. This particular process requires a lot of patience and careful planning of composition, lighting and exposure times. The hard work pays off when finally it all comes together in one unique, magical moment as you watch the photograph slowly develop in front of your eyes. This moment doesn’t happen all the time but when it does you’re left with one of a kind image (plate).`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'STI0202',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STI0201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STI0202.jpg/info.json`],
        headerText: `<h5>Paloma Rincon</h5>`,
        bodyText: `<i>Mexican Feast</i><br><br>Mexican Feast is a celebration of Mexican culture through its gastronomy and its handcraft traditions. In this series I bring these two worlds together in compositions that mix the edible with the imaginary. As a Mexican born photographer, the influences of colour, textures, bright lights and handmade goods form an important part of my style. My images juxtapose Mexican food platters and ingredients with traditional handcrafts and recognisable everyday local props. This series was shot in a studio in Madrid, where I am based.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'STI0305',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STI0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0303.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0304.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0305.jpg/info.json`],
        headerText: `<h5>Alessandro Pollio</h5>`,
        bodyText: `<i>Volatile Interests</i><br><br>Volatile Interests is a visual investigation born and developed during the first national lockdown in Milan, Italy. The still lifes, created by the combination of food or other everyday objects easily available at home, come to life on a bare kitchen countertop, a crucial and central element of the domestic environment. The ever-changing nature of light and the use of different perspectives, add a unique flavour to the compositions, which become key memories of the isolation and mementos of the forced quarantine.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'STI0401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}STI0401.jpg/info.json`,
        headerText: `<h5>Kata Zih</h5>`,
        bodyText: `<i>Memento</i><br><br>Autumn of 2020... Pandemic, lockdown, solitude, memories...`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* Still Life */
    /* PRO & OPEN */

    /* Youth */
    {
        paintingId: 'YOU0101',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}YOU0101.jpg/info.json`,
        headerText: `<h5>Pubarun Basu</h5>`,
        bodyText: `<i>No Escape From Reality</i><br><br>I created this picture with the idea of representing the feeling of being trapped in a moment, or in one's own reality. I saw the curtains as the fabrics of the space-time continuum, which those two hands fail to break out of. The shadow cast by the parallel railings on to the fabric also gives the impression of a cage, in which the entity is trapped for eternity.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* Youth */

    /* Students */
    {
        paintingId: 'STU0103',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STU0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STU0103.jpg/info.json`],
        headerText: `<h5>Coenraad H Torlage</h5>`,
        bodyText: `<i>Young Farmers</i><br><br>I was born on a farm in South Africa, and grew up with cattle, horses, donkeys and chickens, many of which I still own and love to this day. Farming is an intense occupation that requires passion and unwavering dedication. I set out to photograph young people who choose this life because, like me, they believe they have a responsibility. This sits heavily on all of our shoulders. South Africa is an unpredictable land with severe droughts, safety concerns and debates around land ownership. Despite these challenges, young farmers are working toward a fairer and more equitable future of sustainable food security. They are my peers, my friends and my family, and this is our time to feed the nation.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'STU0201',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0202.jpg/info.json`],
        headerText: `<h5>Claudia Mauderer</h5>`,
        bodyText: `<i>Yesterday, Today and Tomorrow</i><br><br>Mass-produced fashion forms a significant part of the waste created by consumer culture, but young people are making great efforts to encourage their contemporaries to be more mindful about waste, by promoting recycling, upcycling and reusing. My work aims to capture the ideas around this. South African fashion designer and illustrator Lara Klawikowski created a collection of garments made from recycled, upcycled and reused pieces of plastic, as well as offcuts of industrial material, inspired by flowers I photographed in Kirstenbosch National Botanical Garden.<br>Plastic products contributed R76 billion to South Africa’s economy in 2016 and, according to a report by the industry body Plastics SA, up to 60,000 people work in plastics-related businesses. Fast fashion relies enormously on virgin plastic production; the report estimates 63 per cent of the materials used for clothing in 2015 was virgin plastic, while less than three per cent was recycled material.<br>The yesterday-today-and-tomorrow plant (Brunfelsia pauciflora) has lush, green foliage, accentuated with aromatic blossom that changes in colour. The flowers bloom through three colour-changing cycles over a three-day period. I chose to name my work after it, because yesterday cannot be changed, nor can the impact damage from plastic be reversed; today we aspire to be better; tomorrow we will make changes as we continue to educate and be mindful of waste. `,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'STU0301',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0302.jpg/info.json`],
        headerText: `<h5>Li Yanan</h5>`,
        bodyText: `<i>Live Stream Economy</i><br><br>The exponential growth in live streaming has resulted in a form of online sales that has become the primary means of marketing in China. During the Covid-19 outbreak, shops suffered huge declines in their incomes. However, live streaming created a bridge between merchants and consumers, taking advantage of its all-weather, zero distance, no contact status. Not only did it create new sales channels for traditional industries but also it made up for the losses sustained by the lack of face-to-face sales. The live stream economy is proof of my generation’s ability to innovate and take advantage of our situation.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'STU0401',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0401.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0402.jpg/info.json`],
        headerText: `<h5>Thomas Hengge</h5>`,
        bodyText: `<i>Faces of the Future of Journalism</i><br><br>From fringe internet conspiracies making their way into the mainstream to government officials encouraging the abandoning of trust in the media, I believe we are living through the information age’s darkest and most dangerous time. It is up to us all to shoulder the burden of this conflict, but journalists in particular find themselves on the frontline. Often underpaid and overworked, journalists are driven by a deep sense of purpose.<br>With this project, I am highlighting young, aspiring and working journalists from different walks of life, who have chosen this career despite its potential burdens and dangers. These young adults have chosen to dedicate their lives to the pursuit of truth, with the hope of helping to elevate others, and giving a voice to those who are overlooked and marginalised.<br>Some work in the same town in which they grew up, and focus on uplifting their community. Others travelled from across the world to study and practise journalism in the United States, taking a leap of faith at a young age. They are vastly different in their backgrounds, experiences, interests and outlooks on life. But the commonality that binds them is their unwavering dedication to journalism and the belief that they can make a difference with their work.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'STU0501',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0501.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0502.jpg/info.json`],
        headerText: `<h5>Matias Alejandro Acuña</h5>`,
        bodyText: `<i>Guardians of the Mountain</i><br><br>Every year, thousands of native forests around the world are devoured by flames, with catastrophic results. This project looks at the increase in forest fires in Patagonia, Argentina – a reflection of climate change globally. The region in which the 2,260m-high Piltriquitrón can be found is home to the Mapuche indigenous community. Like their ancestors, they are connected to nature, and live without electricity or fresh water on tap. They are also the first responders to any forest fire, risking their lives, using only the most basic equipment, and fighting to defend their land in temperatures that can reach as high as 60°C.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'STU0603',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0601.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STU0602.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STU0603.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STU0604.jpg/info.json`],
        headerText: `<h5>Irene Facoetti</h5>`,
        bodyText: `<i>(WHO) I Am</i><br><br>According to the World Health Organization (WHO), the growth of mental disorders impacts the health and economies of every country. In Europe, it is said that one in six suffers from a mental disorder. The most common of these is depression, which is estimated to affect at least 264 million people worldwide. In addition, it is estimated that 10-20% of adolescents globally experience mental health conditions, yet these remain underdiagnosed and undertreated.<br>In Italy, the subject of psychology was slow to be taken seriously; the first two degree courses in the subject were introduced as recently as 1971. However, the Covid-19 pandemic highlighted the topic’s importance: according to a survey conducted by the Piepoli Institute for the National Council of the Order of Psychologists, seven Italians out of 10 (compared to two out of 10 in previous surveys) now believe that some form of collective psychological support is essential.<br>For some time, the number of applications to psychology faculties at universities has been on the rise, and the most recent figures reveal an average increase of 20% on the previous year. This demonstrates my peers' interest in the subject, and our commitment to finding solutions that can aid the emotional resilience of the country and sustain its future young people.<br>My project, presented in the form of an archive, features young Italians between the ages of 20 and 30, who, through their own testimonies, provide a general picture of modern society and mental health. As the WHO states, ‘Mental health is not just the absence of mental disorder. It is defined as a state of well-being in which every individual realizes his or her own abilities, can cope with the normal stresses of life, can work productively, and is able to make a contribution to her or his community.’`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'STU0701',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0701.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0702.jpg/info.json`],
        headerText: `<h5>Tayla Nebesky</h5>`,
        bodyText: `<i>Four walls</i><br><br>England is in its toughest lockdown since March 2020. In considering the ways my contemporaries are changing the world, I thought it crucial to acknowledge the most universal experience we are all sharing: staying at home. Reflecting on this idea, these images are of a space I have grown increasingly observant of and familiar with – my home.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'STU0802',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0801.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0802.jpg/info.json`],
        headerText: `<h5>Matias Garcia</h5>`,
        bodyText: `<i>The Voices of the Amazon – Waylla Nuna</i><br><br>My project tells the story of an indigenous community that lives between two rivers: the Ilikulin and the Jatunyacu. Located in Ecuador’s Amazon region, this area has suffered from mining, deforestation and poor touristic practises that have endangered not only water, flora and fauna but also the communities that inhabit it.<br>I wanted to tell the story of the Kichwa community of Serena, whose women have taken leadership of economic and societal activities, deconstructing their patriarchal system and creating a female-led hierarchy. These women provide for their families and protect their environment, while reinventing the way in which indigenous communities interact and function within the industrialised world. With the help of international organisations and local entities, the Serena community has developed a preservation-based culture that educates the younger generations, influences foreign mentalities and, most importantly, takes a stand for its home, its philosophies and its worldview. We need to raise the voices of such communities, and acknowledge their understanding of natural interconnection and our dependence on nature. They are the voices of the future.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'STU0901',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0901.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0902.jpg/info.json`],
        headerText: `<h5>Hannah Davey</h5>`,
        bodyText: `<i>All is for all</i><br><br>Despite the positive shift towards improved diversity and inclusivity in advertising, media and the arts, there remains a gap in the representation of people living with disabilities. Often marginalised and invisible in mainstream media, disabled people represent 15 per cent of the world’s population and globally have more than $10trillion in annual disposable income, according to a 2020 report by Return on Disability. The World Health Organization states, ‘People with disabilities are among the most marginalized groups in the world… Disability is now understood to be a human rights issue. People are disabled by society, not just by their bodies.’<br>In 2019, fashion entrepreneur Grace Stratton co-founded the groundbreaking enterprise, All is for All. This world-first initiative helps those with disabilities to navigate fashion and buy products online. It has since grown into a talent, communications and media agency, breaking boundaries and establishing balance, creating a much-needed space for those with disabilities.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* Students */

    /* 2021 Latin America Competition: LATAM */
    {
        paintingId: 'LAT0101',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LAT0101.jpg/info.json`,
        headerText: `<h5>Facundo Ballesta</h5>`,
        bodyText: `<i>The Last Supper-2008</i><br><br>Appropriation of the original work of Leonardo da Vinci`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT0102',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LAT0102.jpg/info.json`,
        headerText: `<h5>Facundo Ballesta</h5>`,
        bodyText: `<i>The drunks 2011</i><br><br>Appropriation of the original work Diego velazquez`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT0201',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0202.jpg/info.json`],
        headerText: `<h5>Alejandro Prieto</h5>`,
        bodyText: `<i>No border wall</i><br><br>At nearly 2,000 miles long, the US-Mexico border traverses some of the continent’s most biologically diverse regions. This fragile ecosystem is home to a varied population of mammals, reptiles, birds and plants. Many species migrate between the biomes in the south and north of the continent, and will be particularly affected if the US government implements its plans to erect a wall along the border with Mexico. This infrastructure would not only restrict the local movements of wild animals but also fragment their habitats and interrupt the traditional migration routes they have always used.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT0301',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0302.jpg/info.json`],
        headerText: `<h5>Alex Trigo</h5>`,
        bodyText: `<i>Atacama Galaxy</i><br><br>The darkest skies on the planet can be found in Chile’s Atacama Desert. Almost all of these astrophotographs were made there.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT0403',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0401.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT0402.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT0403.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT0404.jpg/info.json`],
        headerText: `<h5>Andrea Alkalay</h5>`,
        bodyText: `<i>Facade</i><br><br>The images shown here are facades; it’s uncertain what purpose they serve. Are they a film set or a training camp for special forces? Perhaps they are ruins that have been secured. In the end, the purpose doesn't matter, because the architecture has become an art space. Light and shadow shape this space and generate the stage. The pictures try to expand the boundaries of photography and dispense pure representation. Everything seems possible and stories emerge from the shadows into the bright light.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT0501',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0501.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0501.jpg/info.json`],
        headerText: `<h5>Andrés Torres Galeano</h5>`,
        bodyText: `<i>Aislados</i><br><br>With deaths from anxiety or depression increasing each year, the consequences of social isolation on mental and physical health can be lethal.<br>Last year, Covid-19 forced millions of people to isolate in their homes. According to the Profamilia Solidaridad study carried out in Colombia, those most affected by episodes of anxiety or depression during the pandemic are aged between 18 and 33 years old.<br>Aislados (Isolated) is an allegory of the anxiety, stress, depression, loneliness and boredom that have arisen from quarantine.<br>I conducted this series between Barcelona and Bogotá by using the camera obscura as a vehicle to talk about changes we experience in the perception of time and space. In contrast, its light becomes an analogy of the hope each portrayed person had of returning to normal life.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT0601',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0601.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0602.jpg/info.json`],
        headerText: `<h5>Loli Laboureau</h5>`,
        bodyText: `<i>Citizen of Tomorrow</i><br><br>Citizens of Tomorrow started as my personal project during the quarantine. It's a work in progress that combines the world as we used to know it and a series of portraits, describing the new normal in a dramatic way.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT0701',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0701.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0702.jpg/info.json`],
        headerText: `<h5>Félix Hernández</h5>`,
        bodyText: `<i>Playing in the house</i><br><br>2020 was a very difficult year for many people and we commercial photographers were no exception.<br>Playing in the House is a selection of some of the photographs I produced at home during lockdown. All were created using scale models and miniature settings that I made, as well as photographing common objects I had within reach. I experimented with effects such as water and smoke, and played with forced perspective and focus stacking. I also created printed backgrounds for the miniature scenes and applied some digital effects.<br>The images are creative and experimental, combining the analogue world with the digital world.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT0801',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0801.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0802.jpg/info.json`],
        headerText: `<h5>Florence Goupil</h5>`,
        bodyText: `<i>Shipibo-Konibo: The Healing Plants</i><br><br>The epicenter of the Covid-19 pandemic has moved to the Peruvian Amazon, endangering the lives of the indigenous Shipibo-Konibo people. In December 2020, more than 209,179 confirmed cases and 3,106 deceased were reported by the Peruvian Department of Indigenous Peoples, including elders and indigenous leaders with the symptoms of Covid-19.<br>Faced with government negligence over the lack of medical care and the collapse of the only Amazonian hospital, the Shipibo-Konibo brought together a group of traditional nurses, named ‘Comando Matico’, in order to heal their people with the use of their plant-based medicines.<br>‘Plants don’t leave us and we don’t leave plants,’ states Ronald Suárez, president of the indigenous organisation Coshikox. Ronald recently lost his mother and states that an encyclopedia of knowledge linked to the use of plants and the biodiversity of the Peruvian Amazon disappears every time an elders dies. Like Ronald, many Shipibo-Konibo consider this situation as a genocide by abandonment.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT0901',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0901.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0902.jpg/info.json`],
        headerText: `<h5>Johis Alarcón</h5>`,
        bodyText: `<i>I am, still</i><br><br>This is a daily life story that explores the world of a young generation of indigenous people who find themselves empowered by their culture without the fear of colonialism. These are young people who have decided to stay in their land, with their families, and develop a lifestyle that combines modernity and ancestral knowledge, rejecting ‘mestizaje’ (interbreeding) with the strength of their identity.<br>In Ecuador, around 7% of the population is indigenous. During the last century, racism and discrimination played a lead role in a model of life where inequality forced many to migrate to the city, abandoning their territory and culture. Globalisation devalued indigenous identity but at the same time fuelled an unpredictable cultural resistance within the indigenous youth. This generation has decided not to leave. They stay in their communities, and lead the defence of the land and culture, creating another way of living and being.<br>The World Health Organization has recommended looking to indigenous and Afro-descendent peoples as natural allies in the fight against the global health emergency. The worldview and ancestral knowledge about health are immediate and invaluable resources, and give clues on how to build a post Covid-19 world.<br>When I started this story, my childhood memories came back to me: the mountains; the family meals; and those cold mornings with the sound of water. My memories become more and more blurred, but, in this community, the young people will not let these experiences become a thing of the past.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT1004',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1001.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT1002.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT1003.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT1004.jpg/info.json`],
        headerText: `<h5>José Luís Rissetti</h5>`,
        bodyText: `<i>Vanilla and Anti-riot Vehicles</i><br><br>During the Chilean protests of 2019-2020, known as the ‘Social Outbreak’, protestors threw bottles of paint at riot control vehicles in order to restrict the drivers’ visibility. My series of images captures these coloured spots in a pictorial style.<br><br>As a counterpart to the colourful images are the ‘Vanillas’, which depict the residue of discharged pellet cartridges. I collected them in Plaza Baquedano, Santiago, and photographed them on a clean, white background, to give a forensic feel.<br><br>These weapons have resulted in more than 460 people in Chile sustaining damage to their eyes or even being blinded.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT1101',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1101.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT1102.jpg/info.json`],
        headerText: `<h5>José María Pérez</h5>`,
        bodyText: `<i>Limbo</i><br><br>A place between places.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT1201',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT1202.jpg/info.json`],
        headerText: `<h5>Morfi Jiménez Mercado</h5>`,
        bodyText: `<i>The (un)Real</i><br><br>These images arise from the feelings of fear, nostalgia and uncertainty that arose from the quarantine. Using images from my archive, and asking my friends and parents to take self-portraits, I converted these digital images into 35mm negatives, then projected them onto a canvas that has the appearance of a portable screen. It gives the idea that what we are experiencing is not real – that it is a movie, or a fiction, which uses the city as a backdrop.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT1301',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT1302.jpg/info.json`],
        headerText: `<h5>Rodrigo Alejando Palavecino Escobar</h5>`,
        bodyText: `<i>¿Quién es aquel?</i>`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT1401',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1401.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT1402.jpg/info.json`],
        headerText: `<h5>Sofia Lopez Manan</h5>`,
        bodyText: `<i>Nature is dead</i><br><br>Nature as we know it is a cultural construction. We view it through our ideas and aesthetic fantasies.<br><br>Nature is dead, and if it is not dead yet we should bury its meaning and put an end once and for all to a romantic and idealised concept that fragments, classifies and separates what is united: the human being.<br><br>Nature is a complex and endless term. It could be the animal kingdom, the bacteria around us, or the universe. We call it our ‘Mother’, as if it is a divine goddess, an abstract idea with human qualities.<br><br>Nature is Dead is a cabinet of curiosities, a diverse visual collection of what we define as nature. My visual journey aims to help us rethink our notion of nature and create a new interconnectedness between all things.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT1501',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1501.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT1502.jpg/info.json`],
        headerText: `<h5>Victor Manuel Zea Díaz</h5>`,
        bodyText: null,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* 2021 Latin America Competition: LATAM */

    /* ALPHA FEMALE  */
    {
        paintingId: 'ALP0101',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0101.jpg/info.json`,
        headerText: `<h5>Adriana Colombo</h5>`,
        bodyText: `<i>The World in my Hands</i><br><br>There is nothing more important than a child for a parent: the world is in his hands.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ALP0201',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0201.jpg/info.json`,
        headerText: `<h5>Anastasia Zherdieva</h5>`,
        bodyText: `<i>Stand on Your Feet</i><br><br>When equestrian vaulting competitions were cancelled due to the pandemic, girls practised elements in the field instead.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ALP0301',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0301.jpg/info.json`,
        headerText: `<h5>Chou Chia Jung</h5>`,
        bodyText: `<i>New Taipei Metropolitan Park</i><br><br>New Taipei Metropolitan Park.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ALP0401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0401.jpg/info.json`,
        headerText: `<h5>Emma Collins</h5>`,
        bodyText: `This shot was taken while we were staying in an old French farmhouse. It was dark and cool, with beautiful slivers of sunlight creeping through the shutters. The moment captures the relationship between my girls at a time when my younger daughter still hangs on to everything her older sister does.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ALP0501',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0501.jpg/info.json`,
        headerText: `<h5>F. Dilek Uyar</h5>`,
        bodyText: `<i>Lake Tuz</i><br><br>An algae called dunaliella salina gives Lake Tuz in Ankara its pink colour in summer; it can be quite surreal. On the edge of the lake is an old fountain where the shepherds occasionally bring their herds during the day, before returning to their grazing. I was lucky to be there at just the right time.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ALP0601',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0601.jpg/info.json`,
        headerText: `<h5>Heun Jung Kim</h5>`,
        bodyText: `<i>Tae Jung and Ha Ru 1</i><br><br>The Korean Baek-il party is a centuries-old tradition. It celebrates a child’s 100th day, and came into being because of Korea’s high infant mortality rate during the 18th century. On the 100th day, a family traditionally prays and gives food offerings to thank the Shaman Spirit of Childbirth for the child having survived this difficult period. During the celebration, parents dress their babies in the traditional Korean 'Hanbok', as worn by my niece Ha Ru in this image. Owing to the Covid-19 pandemic, relatives and friends joined in a video call to celebrate this memorable moment for my niece.<br>This portrait shows my younger sister, Tae Jung, celebrating this milestone with her daughter, and is an attempt to reflect on the vulnerability of life and the strength of motherhood during these unprecedented times.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ALP0701',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0701.jpg/info.json`,
        headerText: `<h5>Hoije Nuuter</h5>`,
        bodyText: `<i>Back to the Beginning 3</i><br><br>The ball in this image was originally a Christmas decoration. I couldn’t find a pure matte-white ball in the shops, so I painted one instead, then took a series of images in a quarry, and made a composite of them in Photoshop.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ALP0801',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0801.jpg/info.json`,
        headerText: `<h5>Jade Lv</h5>`,
        bodyText: `<i>Alone</i><br><br>I know I'm not alone. On the way to find the best view of Mount Gongga.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ALP0901',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0901.jpg/info.json`,
        headerText: `<h5>Jing Shen</h5>`,
        bodyText: `<i>Alone</i>`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ALP1001',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP1001.jpg/info.json`,
        headerText: `<h5>Kulakova Ekaterina</h5>`,
        bodyText: `<i>Altay Spirit</i><br><br>Whisper of the wind, calmness of the Altai mountains, foggy peaks stretch along the horizon of the Kurai steppe. Her chest is filled by the breath of freedom, and her spirit flies over the fields along the mountains, following the wind. Her hands are lifted up by the overwhelming sense of reverence for Mother Nature.<br><br>This is a photo of a beautiful Altai girl in an authentic national costume. This photo is a part of my folk photo project, dedicated to the female portrait of the Nationalities of Russia. So that the memory of our cultures and identity does not disappear, in order to preserve the cultural heritage, in order to draw attention to the beauty, value and respect of each nationality, I convey this to the viewer, through art - a photo portrait, costume and everyday life, - and tell people about them.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ALP1101',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP1101.jpg/info.json`,
        headerText: `<h5>Mireia Vilaplana</h5>`,
        bodyText: `<i>Masquerade III</i><br><br>This image is part of a series shot during the 2020 lockdown. Called 'Masquerade, a visual exploration of our true selves', it aims to explore photography’s particular ability to describe a historical moment in a conceptual form. Each photograph encourages the viewer to question the way in which we reveal ourselves to others. Has society turned into one big masquerade ball?`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ALP1201',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP1201.jpg/info.json`,
        headerText: `<h5>Tatyana Nemova</h5>`,
        bodyText: `<i>Swan Horse</i><br><br>An Andalusian horse.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ALP1301',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP1301.jpg/info.json`,
        headerText: `<h5>Sabrina Pantano</h5>`,
        bodyText: `<i>Nature Will Save Us</i><br><br>One day during lockdown, I was out walking with my niece. Suddenly, she slipped into a bush and used it as camouflage, as if to protect herself.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* ALPHA FEMALE  */

    /* GRANT */
    /* GRANT: Professional */
    {
        paintingId: 'PRO0103',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PRO0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0103.jpg/info.json`],
        headerText: `<h5>Ronny Behnert</h5>`,
        bodyText: `<i>Venezia: La Serenissima</i><br><br>This is a very personal project, which I started in 2012. Venice is my favourite city in the world, and I travel there at least four to six times a year in order to capture its hidden beauty. There is more to this unique city than its renowned tourist sights. It also has a vulnerable side, which is only visible to those who take a closer look behind its dusty curtain. I love to capture the atmospheric, morbid, majestic face of Venice seen by only a few people as they pass by on their way to the likes of Piazza San Marco, San Giorgio Maggiore or Ponte di Rialto.<br>This peaceful world is under threat. Tourism is a problem, but not the main problem. The water, which makes this place so special, is reclaiming the city. Every year, it rises higher during the monthly Aqua Alta (high tide) and, little by little, it is destroying the buildings.<br>The city is sinking by a few millimetres each year, with climate change being a big factor.<br>When I started taking photographs of Venice in 2012, I didn't even notice the high tide, because the water level did not reach most of the city’s buildings. Now, during a full moon and with a soft wind from the south, the water can reach levels of 140cm or higher. At some point during every visit over the past three years, I have had to wade through water to reach the places I wanted to go. Attempts by the Italian government to fight the problem have failed either through poor planning or high cost. The most recent project, known as MOSE, is at a standstill because of rising costs. It is, perhaps, the last chance to rescue Venice.<br>Although Venice isn’t big, I am still discovering new places, even after 20 visits, and I want to capture every fascinating corner of this extraordinary city before it is gone forever. Travelling and staying there is expensive, and I usually stay between eight and 13 days, in order to get the timing right for my images. Once the body of work is complete, I plan to stage an exhibition and make a photo book of my images, with the aim of keeping Venice alive, even if there comes a time when it no longer exists. `,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'PRO0203',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PRO0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0203.jpg/info.json`],
        headerText: `<h5>Robin Hinsch</h5>`,
        bodyText: `<i>Junglă</i><br><br>Most of the EU’s last remaining primeval forests are found in Romania. These old-growth forests are designated national parks and UNESCO World Heritage Sites, and are home to rare species such as bear, wolf, lynx and wildcat. However, they are under immediate threat from commercial and illegal logging, and from the risk of wildfires. Their eradication is Europe’s biggest and most critical nature conservation issue today, but almost nobody is taking notice, except for a few local activists and rangers, who are alarmed at the levels of violence illegal loggers are willing to use in order to steal wood.<br>That wood can end up anywhere across Europe, and is used for furniture, paper or building materials. If no action is taken now, many of these valuable forests will be gone within the next few years.<br>I would like to spend several weeks in northern Romania, investigating the areas where logging and fires are happening. Together with the local people, I want to develop a new photographic body of work that not only deals with the challenges that arise from the illegal activities but also brings attention to rich cultural environments such as, for example, the Maramureș region in the Carpathian mountains.<br>I would see this opportunity as a natural continuation of my existing work. In the past year I have worked on several projects tackling the topics of untamed economic growth and the ecological consequences.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'PRO0303',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PRO0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0303.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0304.jpg/info.json`],
        headerText: `<h5>César Dezfuli</h5>`,
        bodyText: `<i>The Passengers</i><br><br>My project seeks to put a face to those who have had to migrate, analysing the impact that this form of movement has on the identity of migrants.<br>On 1 August, 2016, 118 people were rescued from a rubber boat drifting in the Mediterranean Sea, 20 nautical miles off the Libyan coast – just another of the hundreds of boats that have been rescued from this migratory route in recent years. In 2016 alone, 181,436 migrants were rescued safely, while 4,576 lost their lives at sea.<br>But who are the people behind these numbers? What are the identities of the victims and survivors of this journey?<br>In an attempt to put names and face to this reality, I photographed the 118 people who travelled on board this boat, minutes after their rescue. Their faces, their expressions and the marks on their bodies reflected the mood and physical state in which they found themselves after a long journey that had already marked their lives forever.<br>But that was just the beginning of this investigation that has continued to evolve ever since. I soon realised that, in those first portraits, the individuals lacked real identity. They were not themselves, but were instead people whose experiences had made them dilute their identities. Sometimes those identities had been hidden, because of fear, and in other cases they had been stolen because of abuse and humiliation.<br>Over the past three years, I have worked to locate these 118 people, who are now scattered throughout Europe, to understand and document their real identity, showing that all they needed was a peaceful context in order to flourish again.<br>To this day, I have met 63 of them, and I have located 105, in countries such as Italy, Germany, France, Spain, Belgium, Malta, Holland and Switzerland.<br>‘Passengers’ is ongoing, and the objective of receiving the Sony Professional Grant is to meet, photograph and interview the remaining people who were on the boat. The information and stories I plan to gather mean I will be able to disseminate the story of the boat and its ‘protagonists’ with sensitivity and accuracy.<br>My ultimate aim is that the stories will lead to a deeper understanding of the reasons why these people left their homes, and to increase empathy within our society. Although ‘Passengers’ has its basis in photography, it will be complemented by other materials such as maps, handwritten texts, physical objects, video and sound. For all this, I believe that with new Sony equipment I will be able to improve the project visually. The objective is to generate enough material to make this a multiplatform project, which can be distributed through the media, through exhibitions and in digital format, with a web documentary that is under development.<br>It is an in-depth project, which provides a new narrative in terms of documenting migration. Its development so far has generated interest from the public and I hope its impact will be enhanced once the project is finished.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },


    /* GRANT: Professional */

    /* GRANT: Students */
    {
        paintingId: 'GST0103',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}GST0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0104.jpg/info.json`],
        headerText: `<h5>Chip Skingley</h5>`,
        bodyText: `<i>Swim</i><br><br>This two-year project focuses mainly on what attracts someone to the sea. I have spent most of my life just steps away from coastal waters, and belonging to a seafaring family has resulted in my being totally consumed by the feeling of being at one with the sea. This fascination with water has resulted in me travelling to many different coasts of Britain while turning my lens towards others’ relationships with the sea.<br>Far from being a ‘screensaver’ tropical ocean, the British waters have a raw and often harsh beauty. They are unlike any other in the world I have experienced.<br>Swimmers, divers, surfers and cold-water enthusiasts provide wide-ranging possibilities for portraits, and I anticipate there is plenty of scope for my idea to evolve. Attractions of the sea include mental release, combatting health problems, exercise and as a social activity. These portraits, in conjunction with images of the changing tides and swell, show the simple nature of being up against or as one with such a dominating force, in all its beautiful complexity. With these images, I aim to unlock some of the mystery of our attraction to water.<br>I am attempting to research the psychological link between humans and the water, along with the history of our relationship with it. This involves interviewing those whom I document, in order to obtain a greater understanding of what I am trying to create.<br></br>Furthermore, I have generated a booklet of images for my own use to reflect on the relationship between people and their relationship with the sea. This is proving to be a useful tool in helping to bring images together while also allowing me to recognise the images’ strengths and weaknesses. This has meant that I have been able to document the attitude of subjects in my images so far and then to connect paths into other environmental themes. A clear example of this is that of the push against climate change and how the  ever-changing landscape of the oceans educates us.<br>By taking this project further, I believe the documentation of selected individuals in this environment will educate and help generate a respect for the oceans, with the aim of instigating a behavioural change within society. Such change is sorely needed, as is drastic action to protect these waters, as well as showing the benefits of seas and oceans to humankind.<br>With the help of the Sony grant, I plan to shoot more subjects in the sea. With more specialist equipment, such as professional water housing, I will be able to create a stronger personal relationship with those I enter the water and swim with. Where I would have once had to stop short, to protect my camera, this grant will bring a whole new exciting perspective to my work.<br>Given that my project revolves around the seas of Britain, the harsh and unforgiving yet beautiful waves of winter have also stopped me in my tracks at times. With equipment such as a thicker-skinned wetsuit, I will be able to stay in the water for longer periods of time, being the first to enter and the last to get out. This grant would allow me to work with the 20-plus people I have in place and who are ready to be documented in a safe and effective manner after the Covid-19 lockdown has ended. The grant from Sony will allow me to reach these people and tell their stories, and in doing so produce an in-depth project that will give insight to those who choose a life on and in the water.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'GST0203',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}GST0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0203.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0204.jpg/info.json`],
        headerText: `<h5>Reyad Abedin</h5>`,
        bodyText: `<i>In Search of Lost Tune</i><br><br>Why do we feel that we belong in one particular place and not in others? Our sense of place and identity are intricately bound to one another. They coexist, as people come to identify with where they live, where their homes are, and where they truly belong. We hold narratives close, and memories of spaces and places shape us. I will be exploring the relationship between place and identity, and the role of place in social and psychological development. The bonds between place and identity can influence social structures, cultural practices and political actions.<br>Like so many groups of emigrants or internally displaced peoples who have tried to establish themselves in a new city or country, I moved away from my family 12 years ago. My hometown of Noakhali is in the southeast of Bangladesh, bordered by the Meghna estuary and the Bay of Bengal on its south side. This area is also significant in terms of British Colonial history of partition.<br>The district is located on the tidal floodplain of the Meghna River delta, and is characterised by flat land. The area is influenced by diurnal tidal cycles; the tidal fluctuations vary depending on the season and are most pronounced during monsoon season. People from this area regularly fall victim to climate change and river erosion. Thousands of homes are destroyed, then rebuilt. If those new homes are also swallowed up by flooding, their owners often move away permanently.<br>With my images, I will walk you through my memories and experiences of being a displaced person, by photographing my place, identity, my route and my home, to ultimately portray what home means to anyone who has to move – whether for reasons of climate change or partition.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* GRANT: Students */
    /* GRANT */


    /* NA: National Awards */
    {
        paintingId: 'NAT0101',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT0101.jpg/info.json`,
        headerText: `<h5>Patrick Mueller</h5>`,
        bodyText: `<i>Hourglass</i><br><br>A snaking dune in Death Valley meets the saddle of the surrounding mountains.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT0201',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT0201.jpg/info.json`,
        headerText: `<h5>Saowanee Suntararak</h5>`,
        bodyText: `<i>Autumn Float</i><br><br>Mount Fuji is hugely popular with photographers, particularly in autumn. I love taking photographs in this season, too.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT0301',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT0301.jpg/info.json`,
        headerText: `<h5>Evgeniy Ivanov</h5>`,
        bodyText: `<i>Silently in the Mountains</i><br><br>A home, immersed in complete silence, and forgotten about until spring. `,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT0401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT0401.jpg/info.json`,
        headerText: `<h5>Aljaž Žnidaršič</h5>`,
        bodyText: `<i>Julian Alps</i><br><br>My friend and I were on our first climb of the winter. We’d hoped to ascend three mountains on the same ridge, but because of the conditions, we had to turn back before the final peak. This image expresses the struggle we faced in deciding whether to turn round or continue.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT0501',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT0501.jpg/info.json`,
        headerText: `<h5>Michaela Steiner</h5>`,
        bodyText: `<i>Horse Against Black Background</i><br><br>I photographed this beautiful horse in the entrance to its stable, using only natural light and a black background. `,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT0601',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT0601.jpg/info.json`,
        headerText: `<h5>Davide Giannetti</h5>`,
        bodyText: `<i>Fox Portrait</i><br><br>Following a hard rainfall in the National Park of Abruzzo, I spotted this wild red fox looking for food.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT0701',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT0701.jpg/info.json`,
        headerText: `<h5>Shreejit Borthakur</h5>`,
        bodyText: `<i>Water Buffalo</i><br><br>A beast from the forests of northeastern India.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },

    {
        paintingId: 'NAT0801',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT0801.jpg/info.json`,
        headerText: `<h5>Jānis Paļulis</h5>`,
        bodyText: `<i>Glowing Mushroom</i><br><br>Light painting one evening in a Latvian forest.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT0901',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT0901.jpg/info.json`,
        headerText: `<h5>Alex Pansier</h5>`,
        bodyText: `<i>Hello World</i><br><br>I photographed this ant as it looked through an autumn leaf in a forest near my home.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT1001',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT1001.jpg/info.json`,
        headerText: `<h5>Min Min Zaw</h5>`,
        bodyText: `<i>Foggy Morning Fishing</i><br><br>This scene shows a father and son catching fish early one winter morning. In Myanmar, children work with their parents to bring in an income for the whole family.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT1101',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT1101.jpg/info.json`,
        headerText: `<h5>Mathis Vandermeeren</h5>`,
        bodyText: ``,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT1201',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT1201.jpg/info.json`,
        headerText: `<h5>Thoedoros Apeiranthitis</h5>`,
        bodyText: `<i>Foggy Farming</i><br><br>At 1,003m, Mount Zas (or Zeus) dominates the Greek island of Naxos. One day in early April, I decided to make my way to the top. By the time I was halfway up, the fog had become so dense it completely obscured the base of the mountain, making me feel as if I was flying. I noticed a small herd of sheep grazing peacefully in this strange environment. I took a shot before moving on and becoming lost in the fog.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT1301',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT1301.jpg/info.json`,
        headerText: `<h5>Matti Virtanen</h5>`,
        bodyText: `<i>Night</i><br><br>I may not have managed to capture any meteors during the Perseids of 2020, but I did get this night shot, which is full of wonder. The exposure was 30 seconds long, and shot at ISO 4000, using a tripod.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT1401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT1401.jpg/info.json`,
        headerText: `<h5>Viktor Einar Vilhelmsson</h5>`,
        bodyText: `<i>Vestrahorn</i><br><br>Vestrahorn is a beautiful mountain that appears almost to rise out of the sea. The scenery that blends in with it makes an impressive sight.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT1501',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT1501.jpg/info.json`,
        headerText: `<h5>Tomislav Veic</h5>`,
        bodyText: `<i>Driving Through the Ice Forest</i><br><br>After the first snowfall towards the end of 2020, I took my camera to the largest old-growth forest in Croatia. This road runs through it.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT1601',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT1601.jpg/info.json`,
        headerText: `<h5>Zdeněk Vošický</h5>`,
        bodyText: `<i>Light Athletics</i><br><br>An aerial photograph of the sports complex in Nové Město na Moravě.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT1701',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT1701.jpg/info.json`,
        headerText: `<h5>Krisztina Kovács</h5>`,
        bodyText: `<i>Street Workout</i><br><br>Taken from the air, this image captures someone taking a well-deserved rest on a colourful street workout field after a couple of active hours.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT1801',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT1801.jpg/info.json`,
        headerText: `<h5>Emil Wieringa Hildebrand</h5>`,
        bodyText: `<i>Oydis and Gunnar</i><br><br>This is the final picture from a personal shoot I did last October. The year 2020 felt as if we were all banging our heads against a brick wall. Models: Øydis Lundem and Gunnar Hannibal Sökjer-Petersen.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT1901',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT1901.jpg/info.json`,
        headerText: `<h5>Shai Apeloig</h5>`,
        bodyText: `<i>An Iron Balloon’s Dream</i><br><br>Inspired by the expressionist movement, I tried to convey a subjective experience with this image, rather than an objective reality. The image was created by taking individual shots of an oxidised iron structure and recomposing them later into a balloon-like image. During production, I gradually rediscovered and recreated the composition.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT2001',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT2001.jpg/info.json`,
        headerText: `<h5>Wong Chek Poh</h5>`,
        bodyText: `<i>Turn 1 2 3 4 5</i><br><br>A panoramic view of unused taxis parked on the rooftop of this building reveals something of the dire economic situation brought about by the Covid-19 pandemic. Despite the success of several vaccine programmes, it will take a long time for lives to return to pre-Covid days.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT2101',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT2101.jpg/info.json`,
        headerText: `<h5>Sussi C. Alminde</h5>`,
        bodyText: `<i>The Dance</i><br><br>I will not have you without the darkness that hides within you. I will not let you have me without the madness that makes me. If our demons cannot dance, neither can we. Poem by Nikita Gill.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT2201',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT2201.jpg/info.json`,
        headerText: `<h5>Hoije Nuuter</h5>`,
        bodyText: `<i>Back to the Beginning III</i><br><br>The ball in this image was originally a Christmas decoration. I couldn’t find a pure matte-white ball in the shops, so I painted one instead, then took a series of images in a quarry, and made a composite of them in Photoshop.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT2301',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT2301.jpg/info.json`,
        headerText: `<h5>Lauriane Bieber</h5>`,
        bodyText: `<i>Post-Lockdown Cigarette, in the Cold Rain of June</i><br><br>This photograph is a story of first times. The first time I shot my dear friend Léo, who I only had met once, about 10 years ago. The first time I went outside after three months. The first friend I met after lockdown. The first time I worked with a model so brave and so dedicated to art and creation. The first time I felt how much photography was important to me.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT2401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT2401.jpg/info.json`,
        headerText: `<h5>Astrid Susanna Schulz</h5>`,
        bodyText: `<i>Moving Portrait</i><br><br>This image is part of my series, ‘Moving Portraits’, in which I experiment with long exposures of between one and two seconds, and flash. I love these surreal portraits that capture different emotions. They are lightly edited in post-production.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT2501',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT2501.jpg/info.json`,
        headerText: `<h5>Kamila J. Gruss</h5>`,
        bodyText: `<i>The Moon Girl</i><br><br>The Moon Girl, or the dark side of social media, where everyone appears to be happy.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT2601',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT2601.jpg/info.json`,
        headerText: `<h5>Sabbir Hossen</h5>`,
        bodyText: `<i>Her Name is Chandi</i><br><br>A portrait of a child working in a paddy field. She works alongside her parents as it allows her to continue her studies. Her passion was inspiring.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT2701',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT2701.jpg/info.json`,
        headerText: `<h5>Simas Bernotas</h5>`,
        bodyText: `<i>Traditional Crafts: Portrait of a Toymaker</i><br><br>Ancient crafts are imbued with the wisdom of previous generations, with each nation having its own tales and myths about them. For this series, I captured Lithuanian crafters with a mystical spirit in an attempt to show them as devoted caretakers of declining traditions. This image is one of many from that project.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT2801',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT2801.jpg/info.json`,
        headerText: `<h5>Cristina Venedict</h5>`,
        bodyText: `<i>Solitude</i><br><br>The model in this photograph is a young actress by the name of Cezara Munteanu. The picture was taken in my studio in Botosani, Romania, in 2020, a year full of many emotions and inner uncertainties.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT2901',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT2901.jpg/info.json`,
        headerText: `<h5>Vladimir Zivojinovic</h5>`,
        bodyText: `<i>Serbia's Red Gold Pepper Harvest</i><br><br>An elderly woman prepares threads of red paprika in Donja Lokosnica, Serbia. In this village in a valley in South Morava, some 250 of the 280 households are involved in the growing of pepper – although depopulation means this number is in decline. Around 500 tons of ground pepper is produced in a 250-hectare area.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT3101',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT3101.jpg/info.json`,
        headerText: `<h5>Tuan Nguyen Quang</h5>`,
        bodyText: `<i>Waiting</i><br><br>This photograph was taken in Ha Giang, Vietnam. I went into a house in the village and asked permission to take pictures there.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT3201',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT3201.jpg/info.json`,
        headerText: `<h5>Mehmet Aslan</h5>`,
        bodyText: `<i>Astroturf</i><br><br>The pandemic has affected everyone. Since places of worship are closed, these men pray on the Astroturf pitch, while adhering to social distancing.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT3301',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT3301.jpg/info.json`,
        headerText: `<h5>Balint Deak</h5>`,
        bodyText: `<i>Walk Into the Sunset</i><br><br>As I was walking with my girlfriend, I noticed the curve in this road with the sky behind it, so I asked her to walk into the scene. I made the two sides symmetrical in Photoshop.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT3401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT3401.jpg/info.json`,
        headerText: `<h5>Shaun Muramatsu</h5>`,
        bodyText: `<i>Fertility</i><br><br>This picture aims to represent fertility, with floating clouds, wheat fields, snow fields and the earth.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT3501',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT3501.jpg/info.json`,
        headerText: `<h5>Yukihito Ono</h5>`,
        bodyText: `<i>The Last Winter</i><br><br>Photographed in Fukushima, Japan, this train – known as Ki-Ha 40 – was retired from the Tadami Line on 11 March, 2020.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT3601',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT3601.jpg/info.json`,
        headerText: `<h5>Dante Mogni</h5>`,
        bodyText: `<i>Luciano</i><br><br>A man rests naked in a Buenos Aires hotel room, serving his quarantine. They were difficult weeks of loss, but he was in such a state of peace... as if it were all just a bad dream.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT3901',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT3901.jpg/info.json`,
        headerText: `<h5>Eniz Karadzha</h5>`,
        bodyText: `<i>Extraterrestrial Earth – Mars</i><br><br>This dam is usually full, but had dried up. Scenes such as this show the effects of climate change are becoming more obvious. After a couple of weeks spent studying the angle of the sun, not to mention a bit of luck, I managed to take the image I’d hoped for.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT4001',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT4001.jpg/info.json`,
        headerText: `<h5>Sean Channal</h5>`,
        bodyText: `<i>I Miss You</i><br><br>This used to be the place where an audience would relieve their stresses and share their excitement, but since the Covid-19 outbreak, everything has changed. The theatre is now silent and lonely. One day, I hope, things will return to normality.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT4301',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT4301.jpg/info.json`,
        headerText: `<h5>Ramón Rodriguez</h5>`,
        bodyText: `<i>Sanhattan</i><br><br>Santiago’s financial district is known as Sanhattan – a term coined in 1995 by the editor of newspaper La Nación, when he compared the high-rise developments in the neighbourhood of El Golf with those of Manhattan. Over time, the term made its way into common parlance.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT4901',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT4901.jpg/info.json`,
        headerText: `<h5>Mireia Vilaplana</h5>`,
        bodyText: `<i>Masquerade III</i><br><br>This image is part of a series shot during the 2020 lockdown. Called 'Masquerade, a visual exploration of our true selves', it aims to explore photography’s particular ability to describe a historical moment in a conceptual form. Each photograph encourages the viewer to question the way in which we reveal ourselves to others. Has society turned into one big masquerade ball?`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT5001',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT5001.jpg/info.json`,
        headerText: `<h5>Abdelhamid Fawzy Tahoun</h5>`,
        bodyText: `<i>The Mevlevi Dancer</i><br><br>Tanoura is an Egyptian dance, performed in circular motions, which has its spiritual origins in Sufism. Its performers believe that all movement in the universe starts and ends at the same point, so this is reflected in the dance, with the continuous spinning making them appear like planets moving in space.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT5101',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT5101.jpg/info.json`,
        headerText: `<h5>Hardijanto Budyman</h5>`,
        bodyText: `<i>Poems for Sisters</i><br><br>You are angels in disguise<br>Side by side or miles apart<br>Sisters will always be connected by the heart`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT5201',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT5201.jpg/info.json`,
        headerText: `<h5>Hiroki Nose</h5>`,
        bodyText: `<i>Autumn Snake</i><br><br>This is an aerial photograph of a mountain road in Hakone, Japan. The path, when seen from the sky, looked like a snake. Photographed in autumn, the leaves of the coloured trees were extremely beautiful.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT5401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT5401.jpg/info.json`,
        headerText: `<h5>Hyeonmin Cho</h5>`,
        bodyText: `<i>The Fairy of the Forest</i><br><br>This photograph shows a woman wearing the traditional Korean hanbok, with fireflies in the background. The flashing lights of the Luciolinae firefly create a brilliant bokeh, like fairies of the forest. Fireflies live only in clean areas; I aspire to return to a clean world, free of Covid-19.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT5501',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT5501.jpg/info.json`,
        headerText: `<h5>Yong Byung Chae</h5>`,
        bodyText: `<i>Bedroom</i><br><br>A moonlit bedroom.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT5601',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT5601.jpg/info.json`,
        headerText: `<h5>Naser Alomari</h5>`,
        bodyText: `<i>The Queen</i><br><br>This photo was taken in Kuwait. I use Mavic air 2 for this photo. It is hard to choose motion technique specially with drone, After many shots am happy with this result.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT5701',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT5701.jpg/info.json`,
        headerText: `<h5>Yoganathan Yoke</h5>`,
        bodyText: `<i>Long-tailed Macaque</i><br><br>This photograph of a long-tailed macaque, also known as the crab-eating macaque, was taken in the mangrove forest of Kuala Gula, Perak. I went there one evening, hoping to photograph birds or snakes, when I saw a group of macaques foraging in the mud for their last meal of the day. A ray of light from the sunset fell on this macaque just as it looked up. I felt it looked like a gesture of hope for the future.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT5901',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT5901.jpg/info.json`,
        headerText: `<h5>Brian Mena Laureano</h5>`,
        bodyText: `<i>First Breath</i><br><br>Sunrise on the slopes of the Popocatépetl volcano.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT6101',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT6101.jpg/info.json`,
        headerText: `<h5>Prajwal Bhattarai</h5>`,
        bodyText: `<i>Ramaroshan Achham, Nepal</i><br><br>Volleyball is the national sport of Nepal, and is particularly popular in the higher mountains. This entrance through the stone wall leads to a public-school compound where villagers play volleyball once classes have finished. When I made this image, the ground was engulfed with fog, silhouetting the volleyball-playing men.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT6201',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT6201.jpg/info.json`,
        headerText: `<h5>Murray Chant</h5>`,
        bodyText: `<i>Wrong Place Wrong Time</i><br><br>This piece of ice had rolled around in the shallows until it assumed a worn and organic form.<br>I photographed it at dusk and lit it from below.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT6501',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT6501.jpg/info.json`,
        headerText: `<h5>Donell Gumiran</h5>`,
        bodyText: `<i>Looking for Water</i><br><br>In Ethiopia's South Omo, the tribes who live in the valley depend on the Omo River for survival. Sixty-two million Ethiopians lack access to safe water. This is everyday life for them.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT6601',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT6601.jpg/info.json`,
        headerText: `<h5>Abdulla AL-Mushaifri</h5>`,
        bodyText: `<i>Museum of Islamic Art</i><br><br>This Museum of Islamic Art has rapidly become an iconic feature of the Doha landscape. Standing alone on reclaimed land, the building draws a great deal of influence from ancient Islamic architecture, most notably the Mosque of Ibn Tulun in Cairo. Designed by Pritzker Prize-winning architect I.M. Pei, the museum comprises a main building with an adjacent education wing connected by a large central courtyard. The main building is five storeys high, and is topped by a domed atrium within a central tower. The cream-coloured limestone captures the changes in light and shade during the day.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT6701',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT6701.jpg/info.json`,
        headerText: `<h5>Naif Albugami</h5>`,
        bodyText: `<i>Hard Life</i><br><br>I wanted to convey a feeling of despair, showing that everything we have in life has come to a halt, because of the pandemic.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT6801',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT6801.jpg/info.json`,
        headerText: `<h5>Peter Svoboda</h5>`,
        bodyText: `<i>On His Own Path</i><br><br>A lone cross-country skier ascends a hill. I wanted to capture a minimal winter image that had symbolism and suggested a parallel with human life. `,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT6901',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT6901.jpg/info.json`,
        headerText: `<h5>Azelda Olivier</h5>`,
        bodyText: `<i>Colour Theory</i><br><br>This photograph was taken for a project on colour theory; the objective of this photograph was to use a warm colour palette. My aim was to explore colour further by considering its socially constructed meaning. Pink is a colour that is often associated with femininity, and through this image, I aimed to blur the lines between gender stereotypes such as this.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT7001',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT7001.jpg/info.json`,
        headerText: `<h5>Isira Sooriyaarachchi</h5>`,
        bodyText: `<i>Hustle for Survival</i><br><br>On a weekday in August, while I was wandering along Main Street, Colombo, this man caught my attention among the crowds of people and busy traffic. I crossed to the middle of the road and pulled out my phone to capture the life of a worker doing his best to survive during the Covid-19 pandemic.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT7101',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT7101.jpg/info.json`,
        headerText: `<h5>Chia Jung Chou</h5>`,
        bodyText: `<i>Girl in Sunshine</i><br><br>New Taipei Metropolitan Park.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT7201',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT7201.jpg/info.json`,
        headerText: `<h5>Chueh Yu-Liang</h5>`,
        bodyText: `<i>Battlefield</i><br><br>For the people of Taitung in Taiwan, the Bombing of Master Handan is the highlight of the annual Lantern Festival; it’s a cultural ritual I attend every year. While most spectators concentrated on the sedan chair, I noticed the firecracker thrower below, with the scene looking just like a battlefield.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT7301',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT7301.jpg/info.json`,
        headerText: `<h5>Hui Pin Lai</h5>`,
        bodyText: `<i>Fluorescent Tiger</i><br><br>The tiger is an important symbol in Taiwanese culture. Here, I used fluorescent paint to depict its essence.  `,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT3001',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT3001.jpg/info.json`,
        headerText: `<h5>Uriel Montúfar</h5>`,
        bodyText: `<i>Roscasiri</i><br><br>During the traditional ‘Roscasiri’ ceremony, leaders of the local authority in the Pomata district of Peru welcome in the new year, celebrating one of the oldest customs of the Aymara region. In this ceremony, new governors are covered with bread as a symbol of abundance and good fortune for the coming year. These peculiar outfits are made with Pomata bread, famed for its flavour and shape, and use more than 200 loaves. The whole thing can weigh as much as 30 kilos. Legend has it, the more decoration each person wears, the more likely it is to be a good year for agriculture.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT3701',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT3701.jpg/info.json`,
        headerText: `<h5>Melisa Reymundi</h5>`,
        bodyText: `<i>Urquiza Railway Line</i><br><br>Rush-hour crowds make travelling by train tedious and stressful. So much so, they can even make us resent the train itself. One afternoon, I waited and waited for an empty train to arrive. Once my patience paid off, I got on and stood in the middle of one of the carriages, with the aim of making an image that gave it the importance I felt it deserved. My goal was to capture it from the inside, from an aesthetic point of view, showing off the variation of its colours and its characteristics. These things make it unique, but often go unappreciated.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT3801',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT3801.jpg/info.json`,
        headerText: `<h5>Sebastian Carreras</h5>`,
        bodyText: `<i>New Reality</i><br><br>2020 found us locked in a crossroads, losing our freedom to an invisible enemy.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT4101',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT4101.jpg/info.json`,
        headerText: `<h5>Esteban Del Solar Guerra</h5>`,
        bodyText: `<i>Plátano</i><br><br>The banana is a beautiful fruit. Much of the time, we don't appreciate how amazing something this simple can be.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT4201',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT4201.jpg/info.json`,
        headerText: `<h5>Francisca Roura</h5>`,
        bodyText: `<i>Coqueta</i><br><br>Dancer.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT4401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT4401.jpg/info.json`,
        headerText: `<h5>Andrea Ortiz Diaz</h5>`,
        bodyText: `<i>Night in the Tatacoa Desert</i><br><br>The Tatacoa Desert is an arid region of Colombia, near a small town called Villavieja.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT4501',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT4501.jpg/info.json`,
        headerText: `<h5>Esteban Toro</h5>`,
        bodyText: `<i>Mundari Kids</i><br><br>The Mundari of South Sudan is one of the last nomadic tribes to remain separate from the modern world. Despite this, its people have access to the sorts of weapons usually associated with cities. They use these to protect their cattle, whose importance to the Mundari cannot be overestimated. They represent wealth and status, and can even be used as currency and dowries.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT4601',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT4601.jpg/info.json`,
        headerText: `<h5>Luis Salazar</h5>`,
        bodyText: `This photograph was made with the bokeh technique, a butterfly lighting scheme, I wanted to represent the inclusion showing an androgynous being, highlighting the purity and softness of its body, it was captured on a balcony overlooking the city, at 7:00 p.m. . `,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT4701',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT4701.jpg/info.json`,
        headerText: `<h5>Miguel Saenz de Viteri</h5>`,
        bodyText: `<i>Cotopaxi</i><br><br>Cotopaxi is a very important symbol of Ecuador. It took me a year to capture the Milky Way over this volcano.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT4801',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT4801.jpg/info.json`,
        headerText: `<h5>Roberto Valdez</h5>`,
        bodyText: `<i>Sangay at Night</i><br><br>This is the closest and safest point to witness Sangay’s volcanic activity and see its lavascape. It is one of the most active volcanoes in Ecuador.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT4802',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT4802.jpg/info.json`,
        headerText: `<h5>Roberto Valdez</h5>`,
        bodyText: `<i>Sangay's Active Volcano</i><br><br>It rains and is cloudy almost every day in the city of Macas. I waited for the best part of a year for the weather to be good enough to take a picture that shows Sangay’s volcanic activity.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT5801',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT5801.jpg/info.json`,
        headerText: `<h5>Beatriz Salas Buendía</h5>`,
        bodyText: `<i>Ojos rojos</i><br><br>Paloma, la libertad en el confinamiento, este año que vivimos encerrados.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT6001',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT6001.jpg/info.json`,
        headerText: `<h5>Pedro Augusto Meza</h5>`,
        bodyText: `<i>Prayer</i><br><br>This ranch, a horse rescue, is in Primo Tapia, Baja California, and it is the only place where I have actually felt safe this year. One quiet afternoon, when nightfall was almost upon us, I sat down with the horses as they finished eating. This is what that sense of safety looked and felt like.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT6301',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT6301.jpg/info.json`,
        headerText: `<h5>Edgar Asencios</h5>`,
        bodyText: `<i>Puyas de Raimondi</i><br><br>Puyas de Raimondi en el Áreas de Conservación Regional (ACR) Titankayocc. PERÚ<br>Es una imagen panorámica compuesta por 4 fotografías e iluminación puntual con una linterna.<br>Es el bosque de Puyas más grande de Sudamérica que lamentablemente sufre de incendios forestales cada año. Vive en zonas muy altas de la cordillera, vive 100 años y desprende hasta 6 millones de semillas en su vida, es parte de un ecosistema del cual se alimentan algunas aves como el colibrí gigante y murciélagos.<br>Puede llegar a medir 12 metros de altura.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT6401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT6401.jpg/info.json`,
        headerText: `<h5>Pedro Jarque Krebs</h5>`,
        bodyText: `<i>Man of the Forest</i><br><br>There are three species of orangutan in the world, and all are in serious danger of extinction, mainly because of the destruction of their habitats in the jungles of Southeast Asia, which are used for palm oil cultivation. Only 70,000 individuals remain worldwide. Orangutans share approximately 97% of their DNA with humans. Along with chimpanzees and gorillas, they are our closest relatives in the animal world.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT5301',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT5301.jpg/info.json`,
        headerText: `<h5>Hoyong Lee</h5>`,
        bodyText: `<i>Tree in the depths</i><br><br>Tree of life deep in the sea that no one knew.<br>There the tree was growing as big and beautiful as hope.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NAT7401',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NAT7401.jpg/info.json`,
        headerText: `<h5>Lee Changjun</h5>`,
        bodyText: `<i>Space, light and shadow.</i>`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
// {
//         paintingId: '',
//         videoId: null,
//         videoURL: null,
//         iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
//         headerText: `<h5></h5>`,
//         bodyText: ``,
//         // urlLink1Label: ,
//         // urlLink1: ,
//     },
    /* NA: National Awards */

    /* Wall Text */
    {
        paintingId: 'EXIWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Thank You</h5>`,
        bodyText: `Thank you for experiencing the Sony World Photography Awards 2021 virtual exhibition, we hope you enjoyed the display.<br><br>Could you be the next Photographer of the Year? The 2022 Sony World Photography Awards open 1st June, 2021. Don’t miss your chance to receive recognition for your photographs, register your interest now!<br>''worldphoto.org''<br><br>Follow us on the links below<br><br>Also, don’t miss your chance to receive recognition for your photographs, register your interest now on our Webstie link below:`,
        // urlLink1Label: ,
        // urlLink1: ,
        instagramUrl: "https://www.instagram.com/worldphotoorg/?hl=en",
        facebookUrl: "https://www.facebook.com/WorldPhotographyOrganisation",
        linkedInIUrl: "https://www.linkedin.com/authwall?trk=bf&trkInfo=AQHIgmOqpQLEJQAAAXjE3mMgl0-0JfUOb8iZvRpl8zhZFyu9o6MYQM2EeTj7HEsw9FNhiJtV83-dIJPVv4OPiu2yuGrnsFB4EGN_tjzzeRxhs3BxUaHacE2gHNIr5J4QeJBuzUM=&originalReferer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fworld-photography-organisation",
        twitterUrl: "https://twitter.com/WorldPhotoOrg",
        ContactURL: "https://mailchi.mp/f310b271d90e/register-your-interest-to-the-2022-sony-world-photography-awards",
    },
    {
        paintingId: 'WELWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Welcome</h5>`,
        bodyText: `Welcome to the Sony World Photography Awards 2021 virtual exhibition. Created by the World Photography Organisation and sponsored by Sony, the Awards has four competitions: Professional, Open, Youth and Student.<br><br>The 150 or so images you see here highlight the most talented, dedicated and creative photographers from this year’s Awards. More than 330,000 images were entered with photographers from across 220 countries and territories taking part across the four competitions.<br><br>As you travel through this virtual display, you’ll discover finalist entries from the Professional competition, the category winners in the Open competition plus the winning work by the Student Photographer of the Year and Youth Photographer of the Year. Make sure you listen to the audio descriptions of the Professional series to add to your experience of the display.<br><br>Winners of the Alpha Female Award and the Latin America Professional Award, our latest initiatives, are also on show. You’ll also enjoy selected works from the Sony Professional and Student Grant recipients.<br><br>We hope you enjoy viewing this year’s photographs and their power to inform, delight and alter our perceptions. Throughout the year audiences can enjoy our virtual traveling exhibition, where specific regions have dedicated, specially curated rooms within the display.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'INTWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>PROFESSIONAL & OPEN COMPETITION</h5>`,
        bodyText: `<b>PROFESSIONAL COMPETITION</b><br><br>The Professional competition represents the importance of the photographic project. Photographers could submit a body of work interpreting one of the ten categories. More than 145,000 series were submitted this year with 100 photographers shortlisted across the ten categories. Intelligent, intense and revealing, the acknowledged series in the Professional competition teach us something new about the world through the eyes of the greatest photographers of our time. Photographer of the Year is selected from the category winners and is awarded $25,000, global exposure and Sony digital imaging kit.<br><br><b>OPEN COMPETITION</b><br><br>More than 165,000 entries were submitted to this year’s Open competition, which calls on photographers – both established and emerging from a vast range of backgrounds – to submit their most striking single images into one of ten categories. The acknowledged images are rich and varied in their brilliance, celebrating the democratic nature of photography. This year 130 photographers made the shortlist, with 10 category winners announced earlier this year. Open Photographer of the Year is selected from the category winners and is awarded $5,000, global exposure and Sony digital imaging kit.<br><br><b>STUDENT COMPETITION</b><br><br>The Student competition discovers emerging talent in photography and embraces these individuals to enrich and further the medium. Open to academic institutions worldwide, students were asked to submit a body of work responding to the topic ‘Building a Better Future’. Ten shortlisted students were then chosen and given a final brief: to submit a series relating to ‘Our Time’. The Student Photographer of the Year is awarded €30,000 of Sony digital imaging kit for their institution plus global exposure.<br><br><b>YOUTH COMPETITION</b><br><br>The Youth competition encourages the next generation of photographers to nurture their vision. Keeping the medium exciting, dynamic and a space to be truly creative, the competition was open to 12-19 year olds to submit up to three images relating to a specific theme each month. Themes included Composition & Design, Natural World & Wildlife and Street Life. Running from July to December, each month a winner and shortlist was chosen celebrated on our website and social media platforms. The Youth Photographer of the Year, who was chosen from these six monthly winners, is given a range of Sony digital imaging kit, plus global exposure.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ARCWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Architecture, Open competition</h5>`,
        bodyText: `<b>Architecture & Design, Professional competition</b><br>Here we wanted to see images showcasing the art and science of buildings and structures. Both exterior and interior images were welcomed here and photographers could depict their subject in a realistic light or through a more creative approach.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'CREWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Creative, Professional and Open competitions </h5>`,
        bodyText: `Photographers were encouraged to embrace their imagination in this category. From cyanotypes to cutting-edge techniques, creativity was rewarded. Subject matter could be varied and images could be heavily manipulated, as long as the image didn’t misrepresent or mislead.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'PORWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Portfolio, Professional competition </h5>`,
        bodyText: `This category was aimed at photographers who wanted to enter single images into the Professional competition. Judges wanted to see the breadth of a photographer’s work, so imagery could be unrelated in subject matter or narrative and from a variety of different series. Submissions highlighting the photographer’s technical skills went far.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'DOCWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Documentary Projects, Professional competition</h5>`,
        bodyText: `Judges were looking for factual or informative bodies of work about a chosen subject. Projects offering insight into a contemporary issue or presenting a factual story with a news or current affairs agenda were liked by the judges.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ENVWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Environment, Professional competition </h5>`,
        bodyText: `Series that showcased the surroundings or conditions in which a person, animal, or plant lives or operates were ideal for this category. Work that had a fine art approach and addressed environmental issues affecting the world today was applauded by the judges.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LANWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Landscape, Professional and Open competitions</h5>`,
        bodyText: `Projects showing spaces within the world in all their varieties, from large scale aerial shots to intimate views, were entered into this category. The main focus was on the aesthetic quality of the final images.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NWWWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Natural World & Wildlife, Professional and Open competitions</h5>`,
        bodyText: `This category welcomed compelling compositions showing the spirit and behaviour of wildlife around the planet. Macro and close-up photographs of the plants and insects that often go unnoticed were also welcomed in this category.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'PORTWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Portraiture, Professional and Open competitions</h5>`,
        bodyText: `Judges were looking for interesting, original, strong and evocative photographs, and the category was intended to be interpreted in its widest sense. Judges wanted to see images demonstrating a likeness to the subject and convey expression, emotion and / or personality.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'SPOWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Sport, Professional competition</h5>`,
        bodyText: `Series that capture the intensity, emotions and action of the chosen sport subject would fit into this category. Whether capturing professional or amateur athletes, the focus could be on the sportsperson or the sport environment but a strong narrative needed to be presented with a different approach or angle on the sport itself.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'STIWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Still Life, Professional competition</h5>`,
        bodyText: `Often a group or an arrangement of objects, Still Life typically depicts inanimate subject matter. Submissions could be classic or innovative. Judges closely considered the interpretation of the subject (composition, lighting and framing) when viewing the work.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LATWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Latin America Competition</h5>`,
        bodyText: `To celebrate the best dynamic and inspiring photographic work currently created in Latin America, the World Photography Organisation and Sony Latin America launched the Latin America Professional Award. The prize is open to all photographers from Latin American countries entering bodies of work (five to ten images) to the Professional competition.<br><br>Now in its second year, the prize has uncovered some of the most interesting and talented photographers from the region and put their work on a local as well as global stage.<br><br>Andrea Alkalay is this year’s winner. Alkalay receives Sony digital imaging equipment and exposure through a local exhibition alongside the shortlisted series in the Latin America Professional Award.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'ALPWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Sony Alpha Female Award</h5>`,
        bodyText: `The Alpha Female Award stems from the Sony Alpha Universe’s Alpha Female initiative, which focuses on creating opportunities for female professional photographers, videographers, and filmmakers to help foster a richer, more diverse industry where all creators can build strong voices and bodies of work.<br><br>The Alpha Female Award has expanded the programme globally by recognising women photographers who have entered the Sony World Photography Award Open competition. Since its inception two years ago, the award has promoted and celebrated the rich diversity of the medium from an international perspective.<br><br>Adriana Colombo is this year’s winner. She receives Sony digital imaging equipment and worldwide exposure through a dedicated online media campaign.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'SGWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Sony Grant</h5>`,
        bodyText: `<b>Sony Grant - Professional</b><br><br>The Sony Professional Grant programme was introduced in 2016 to further support and create opportunities for individual photographers recognised in the Sony World Photography Awards. Each recipient receives $7,000 (USD) and is loaned Sony digital imaging equipment of their choice (depending on availability) to pursue a personal or long-term project.<br><br>Chosen from the Professional finalists of the Sony World Photography Awards 2020, this year’s recipients are Robin Hinsch (Germany) with Junglă, Ronny Behnert (Germany) with Venezia - Perfect Imperfection and Cesar Dezfuli (Spain) with Passengers.<br><br><b>Sony Grant - Student</b><br>The Sony World Photography Awards’ Outstanding Contribution to Photography title is given to a person who has made a significant impact on the photographic medium throughout their career. This year’s recipient is Graciela Iturbide.<br><br>Born in Mexico City, in 1969 Iturbide enrolled in the Film Center of the Universidad Nacional Autonoma de Mexico but she was soon drawn to the art of still photography as practiced by the Mexican modernist master Manuel Alvarez Bravo. From 1970 to 1971 she worked as Bravo’s assistant accompanying him on his various photographic journeys throughout Mexico.<br><br>Iturbide has had exhibitions at some of the most important museums in Mexico, USA and Europe. She has received numerous international awards and many books of her work have been published in different countries.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NATWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>National Award</h5>`,
        bodyText: `The National & Regional Awards supports photographers of all abilities worldwide and celebrates their achievements. Selected from entries to the Open competition, the National Award winners are given Sony digital imaging kit plus global and local exposure. The programme has rewarded more than 550 photographers and currently operates in 56 countries.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'OCPWT01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Outstanding Contribution to Photography</h5>`,
        bodyText: `The Sony World Photography Awards’ Outstanding Contribution to Photography title is given to a person who has made a significant impact on the photographic medium throughout their career. This year’s recipient is Graciela Iturbide.<br><br>Born in Mexico City, in 1969 Iturbide enrolled in the Film Center of the Universidad Nacional Autonoma de Mexico but she was soon drawn to the art of still photography as practiced by the Mexican modernist master Manuel Alvarez Bravo. From 1970 to 1971 she worked as Bravo’s assistant accompanying him on his various photographic journeys throughout Mexico.<br><br>Iturbide has had exhibitions at some of the most important museums in Mexico, USA and Europe. She has received numerous international awards and many books of her work have been published in different countries.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* Wall Text */

];

export {AnnotationsDB};
